import React, { createContext, useContext, useMemo, useState } from "react";

const GuestHubSearchContext = createContext(null);

export const GuestHubSearchProvider = ({ children }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  const value = useMemo(
    () => ({
      searchOpen,
      openSearch: () => setSearchOpen(true),
      closeSearch: () => setSearchOpen(false),
      toggleSearch: () => setSearchOpen((open) => !open),
    }),
    [searchOpen]
  );

  return (
    <GuestHubSearchContext.Provider value={value}>
      {children}
    </GuestHubSearchContext.Provider>
  );
};

export const useGuestHubSearch = () => {
  const ctx = useContext(GuestHubSearchContext);
  if (!ctx) {
    return {
      searchOpen: false,
      openSearch: () => {},
      closeSearch: () => {},
      toggleSearch: () => {},
    };
  }
  return ctx;
};
